import React from "react";
import { useSelector } from "react-redux";

export function withReduxData(Component) {
  return (props) => {
    const reduxState = useSelector((state) => state);
    const propsToDispatch = { ...props, ...reduxState };

    return <Component {...propsToDispatch} />;
  };
}
